import type { ReactNode } from "react";
import React, { useEffect } from "react";

import useScrollDirection from "../../hooks/useScrollDirection";
import useSessionStore from "../../stateManagement/sessionState/sessionStore";

type Props = {
  children: ReactNode;
};

const ScrollManager = ({ children }: Props): React.JSX.Element => {
  const { scrollDirection } = useScrollDirection();
  const atTop = useSessionStore((store) => store.atTop);

  useEffect(() => {
    if (scrollDirection === "up" || atTop) {
      document.body.classList.add("header-visible");
      return;
    }
    if (scrollDirection === "down" && !atTop) {
      document.body.classList.remove("header-visible");
      return;
    }
  }, [scrollDirection, atTop]);

  return <>{children}</>;
};

export default ScrollManager;
